/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Messages_Error_Retry1Inputs */

const en_coinvestments_messages_error_retry1 = /** @type {(inputs: Coinvestments_Messages_Error_Retry1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Coinvestments_Messages_Error_Retry1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_messages_error_retry1 = /** @type {((inputs?: Coinvestments_Messages_Error_Retry1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Messages_Error_Retry1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_messages_error_retry1(inputs)
});
export { coinvestments_messages_error_retry1 as "coInvestments_messages_error_retry" }